import * as React from 'react';
import classnames from 'classnames';
import { PrimaryButton } from '@fluentui/react';
import { Zusatzadresse } from 'api/zusatzadresse';
import { ZusatzadresseTypLabel } from 'utils/labels';
import { formStyles } from 'styles/formStyles';
import { Timestamps } from 'formComponents/Timestamps';
import { laenderByIkz2Selector } from 'store/lookups/selector';
import { useSelector } from 'react-redux';

interface ZusatzadresseItemProps {
    zusatzadresse: Zusatzadresse;
    editZusatzadresse: () => void;
}

export const ZusatzadresseItem: React.FC<ZusatzadresseItemProps> = ({ zusatzadresse, editZusatzadresse }) => {
    const laenderByIkz2 = useSelector(laenderByIkz2Selector);
    return (
        <div
            className={classnames(formStyles.listItem, {
                [formStyles.archived]: zusatzadresse.archiv,
            })}
        >
            <div className={formStyles.topBlock}>
                <div>
                    <div className={formStyles.listTitle}>{zusatzadresse.name1 + ' ' + zusatzadresse.name2}</div>
                    <div className={formStyles.archivedTest}>{zusatzadresse.archiv && '(archiviert)'}</div>
                </div>
                <div />
                <div>
                    <PrimaryButton
                        onClick={() => {
                            editZusatzadresse();
                        }}
                        text="Bearbeiten"
                    />
                </div>
            </div>

            <div className={formStyles.line}>
                {ZusatzadresseTypLabel[zusatzadresse.typ] || zusatzadresse.typ}
                {zusatzadresse.std ? ', Standard' : ''}
            </div>

            <div className={formStyles.line}>
                <div className={formStyles.line}>
                    {zusatzadresse.plz} {zusatzadresse.ort}, {zusatzadresse.strasse}
                    {zusatzadresse.land && ', ' + (zusatzadresse.land ? laenderByIkz2[zusatzadresse.land]?.text : '')}
                </div>
            </div>

            <Timestamps
                modifiedDate={zusatzadresse.updDat}
                modifiedDecimalTime={zusatzadresse.updUhr}
                modifiedUser={zusatzadresse.updUser}
                showCreated={false}
            />
        </div>
    );
};
